import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import cn from 'classnames';
import { sanitizeRowProps } from '../util.js';
import { FocusScope } from '@react-aria/focus';

var _excluded = ["row", "index", "instance", "headerGroups"];

var renderCell = function renderCell(cell, row) {
  var props = _extends({}, cell.getCellProps(), {
    className: cn('yt-table__cell', cell.column.className, {
      'yt-table__cell--align-left': cell.column.align === 'left',
      'yt-table__cell--align-right': cell.column.align === 'right'
    }),
    style: _extends({}, cell.column.style, {
      flex: typeof cell.column.flex === 'function' ? cell.column.flex(row) : cell.column.flex
    })
  });

  return React__default.createElement("div", Object.assign({}, props, {
    role: "gridcell"
  }), cell.render('Cell') || null);
};

var Row = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var row = _ref.row,
      index = _ref.index,
      instance = _ref.instance,
      rowProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var activeIndex = rowProps.activeIndex,
      onRowClick = rowProps.onRowClick,
      rowClassName = rowProps.rowClassName,
      rowExpansionRenderer = rowProps.rowExpansionRenderer,
      rowHeight = rowProps.rowHeight,
      setActiveIndex = rowProps.setActiveIndex,
      style = rowProps.style,
      inlineEditingUniqueId = rowProps.inlineEditingUniqueId;
  var sanitizedRow = sanitizeRowProps(row, rowExpansionRenderer);

  var props = _extends({}, row.getRowProps(), {
    style: _extends({}, style, {
      minHeight: rowHeight ? rowHeight + "px" : undefined,
      paddingLeft: row.depth ? row.depth * 2 + "rem" : undefined
    }),
    className: cn('yt-table__row', {
      'yt-table__row--active': activeIndex === index,
      'yt-table__row--clickable': !!onRowClick,
      'yt-table__row--dragging': !!row.isDragging,
      'yt-table__row--editing': !!row.isEditing
    }, typeof rowClassName === 'function' ? rowClassName(sanitizedRow) : rowClassName),
    onClick: onRowClick ? function (event) {
      if (event.target === event.currentTarget || event.target.classList.contains('yt-table__cell')) {
        event.preventDefault();
        event.persist();
        setActiveIndex(index);
        onRowClick(sanitizedRow);
      }
    } : function () {
      setActiveIndex(index);
    }
  });

  var cells = row.cells;

  if (row.depth > 0) {
    cells = row.cells.filter(function (cell) {
      return !cell.column.hiddenOnSubRows;
    });
  }

  var expandedRow = rowExpansionRenderer && row.isExpanded && React__default.createElement("div", null, rowExpansionRenderer(sanitizedRow, instance));
  var rowContent = React__default.useMemo(function () {
    return React__default.createElement(React__default.Fragment, null, React__default.createElement(FocusScope, {
      key: row.original._createKey,
      contain: true,
      restoreFocus: true,
      autoFocus: true
    }, React__default.createElement("div", Object.assign({}, props, {
      role: "row",
      ref: ref
    }), React__default.createElement("input", {
      type: "hidden",
      name: "_rowIndexPath",
      value: row.id
    }), React__default.createElement("input", {
      type: "hidden",
      name: "_inlineEditingUniqueId",
      value: row.original[inlineEditingUniqueId]
    }), cells.map(function (cell) {
      return renderCell(cell, sanitizedRow);
    }))), expandedRow);
  }, [row.original._createKey]);

  if (row.isEditing) {
    return rowContent;
  }

  return React__default.createElement(React__default.Fragment, null, React__default.createElement("div", Object.assign({}, props, {
    role: "row",
    ref: ref
  }), cells.map(function (cell) {
    return renderCell(cell, sanitizedRow);
  })), expandedRow);
});

export { Row };
//# sourceMappingURL=renderRow.js.map
